import React from 'react';
import { UncontrolledAlert } from "reactstrap";
import { Link } from 'react-router-dom';

const Popup = () => {
    return (
        <React.Fragment>
            <UncontrolledAlert className="card cookie-popup shadow rounded py-3 px-4">
                <p className="text-muted mb-0 fs-6">Bu web sitesi, size harika bir kullanıcı deneyimi sunmak için çerezler kullanmaktadır. Siteyi kullanarak, 
                    <Link to="/page-privacy" className="text-success h6"> çerez kullanımımızı</Link> kabul etmiş olursunuz.</p>
                <div className="cookie-popup-actions text-end">
                    {/* <button>
                        <i className="uil uil-times text-dark fs-4"></i>
                    </button> */}
                </div>
            </UncontrolledAlert>

        </React.Fragment>
    );
}

export default Popup;